import { select, event, format, timeFormat } from "d3";
import { mouseDate, roundDate } from "../../../_core/charts/TechnicalAnalysis";

// ==== Custom functions for Model Forecast Analysis Chart ==================================================================
export function hoverModelFcst(
  D3Chart,
  _this,
  chartDataRaw,
  dataModel,
  dataFcst,
  customName,
  _dateFormat,
  _currencyFormat,
  close2,
  close3
) {
  const svg = _this.chartElements.svgNodeModel;
  _this.settings.date = timeFormat(_dateFormat)(chartDataRaw.at(-1).date);
  _this.settings.close = format(_currencyFormat)(chartDataRaw.at(-1).close);

  const mouseOver = function() {
    event.preventDefault();
    const yPixels = Math.max(
      Math.min(event.layerY - svg.margin.top, svg.height),
      0
    );

    const xt = svg.x;
    const yt = svg.y;

    const xPixels = Math.max(
      Math.min(event.layerX - svg.margin.left, svg.width),
      0
    );
    let dat = roundDate(xt.invert(xPixels));
    let selData;
    let dataMdl;
    let dataF;
    let highlightCandles = true;
    let highlightLineAreas = true;
    // chart data raw
    if (dat <= chartDataRaw.at(-1).date) {
      selData = mouseDate(xt.invert(xPixels), chartDataRaw);
      _this.settings.date = timeFormat(_dateFormat)(selData.date);
      _this.settings.close = format(_currencyFormat)(selData.close);
    } else {
      _this.settings.date = timeFormat(_dateFormat)(chartDataRaw.at(-1).date);
      _this.settings.close = format(_currencyFormat)(chartDataRaw.at(-1).close);
      selData = JSON.parse(JSON.stringify(chartDataRaw.at(-1)));
      selData["date"] = dat;
      highlightLineAreas = false;
    }

    // Model
    if (dataModel.length > 0) {
      if (dat <= dataModel.at(-1).date && dat > dataModel[0].date) {
        dataMdl = mouseDate(xt.invert(xPixels), dataModel);
      } else {
        dataMdl = JSON.parse(JSON.stringify(dataModel.at(-1)));
        dataMdl["date"] = dat;
        highlightCandles = false;
      }
    }
    // Data forecast
    if (dataFcst.length > 0) {
      if (dat <= dataFcst.at(-1).date) {
        dataF = mouseDate(xt.invert(xPixels), dataFcst);
      } else {
        dataF = JSON.parse(JSON.stringify(dataFcst.at(-1)));
        dataF["date"] = dat;
      }
    }
    const xPix = xt(selData.date);
    const xPix3 = xt(dataF.date);
    const yt2 = svg.y2;

    const ytList = [yt, yt, yt];
    const xPixList = [xPix, xPix3, xPix];
    const dataYtList = [
      dataMdl && highlightCandles ? dataMdl : {},
      dataFcst.length > 0 && highlightCandles ? dataF : {},
      highlightLineAreas ? selData : {}
    ];
    const keyYtList = [close2, "mean", "close"];
    const txt = `
      <table class='text-center table table-dark table-borderless table-sm table-tooltip mt-0 mb-0'>
        <thead>
          <tr>
            <th colspan='2' class='table-tooltip-bdr-b' style='min-width: 180px; padding-bottom: 5px!important;'>
              FORECAST ANALYSIS
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class='text-left'><span class='table-tooltip-small'>DATE:</span></td>
            <td class='text-right'>${timeFormat(_dateFormat)(dataMdl.date)}</td>
          </tr>
          <tr>
            <td class='text-left'><span class='table-tooltip-small'>MODEL:</span></td>
            <td class='text-right' style='color: var(--fwd)!important;'>${format(
              _currencyFormat
            )(dataMdl[close2])}</td>
          </tr>
          <tr>
            <td class='text-left'><span class='table-tooltip-small'>${close2}:</span></td>
            <td class='text-right' style='color: var(--symmetry)!important;'>${
              dataFcst.length > 0
                ? format(_currencyFormat)(dataF[close3])
                : "N/A"
            }</td>
          </tr>
        </tbody>
      </table>
    `;
    const showFcst = dataFcst.length > 0 && dataMdl[close2] < dataF[close3];
    // Showing elements
    for (let hoverElement of D3Chart.hoverElements) {
      hoverElement.show({
        yPixels,
        xPix,
        selData,
        dateFormat: _this.settings.dateFormat,
        xt,
        highlightCandles,
        customName,
        textField: txt,
        formatyInside: false,
        yInsideTooltipWidth: dataMdl,
        calcPos: showFcst,
        className: `${customName}${+selData.date}`,
        yPixelsInside: showFcst ? yt2(dataF[close3]) : yt2(dataMdl[close2])
      });
    }

    for (let [index, hoverElementDot] of D3Chart.hoverElementDots.entries()) {
      hoverElementDot.show({
        xPix: xPixList[index],
        yt: ytList[index],
        dataYt: dataYtList[index],
        keyYt: keyYtList[index],
        i: index
      });
    }

    if (!highlightCandles) {
      select(".y-inside-tooltip-model-forecast")
        .style("left", "-1000000px")
        .style("top", "0px")
        .style("opacity", 0)
        .html("");
      select(".dot" + D3Chart.name + 0).style("opacity", 0);
      select(".dot" + D3Chart.name + 1).style("opacity", 0);
    }
    if (!highlightLineAreas) {
      select(".dot" + D3Chart.name + 2).style("opacity", 0);
    }
  };
  const mouseLeave = function() {
    // Hiding elements
    for (let hoverElement of D3Chart.hoverElements) {
      hoverElement.hide();
    }
    for (let hoverElement of D3Chart.hoverElementDots) {
      hoverElement.hide();
    }
    _this.settings.date = timeFormat(_dateFormat)(chartDataRaw.at(-1).date);
    _this.settings.close = format(_currencyFormat)(chartDataRaw.at(-1).close);
  };
  setupMouseEvents(_this, svg, customName, "", mouseOver, mouseLeave);
}

export function ComparisonHover(
  _this,
  D3Chart,
  chartDataRaw,
  dataFcst,
  dataHistorical
) {
  const svg = _this.chartElements.svgNode;
  function mouseover() {
    const yPixels = Math.max(
      Math.min(event.layerY - svg.margin.top, svg.height),
      0
    );

    const xPixels = Math.max(
      Math.min(event.layerX - svg.margin.left, svg.width),
      0
    );
    const xt = svg.x;
    let dat = roundDate(xt.invert(xPixels));
    let selData;
    let highlightCandles = true;
    let dataHist;
    let dataF;
    // chart data raw
    if (dat <= chartDataRaw.at(-1).date) {
      selData = mouseDate(xt.invert(xPixels), chartDataRaw);
    } else {
      selData = JSON.parse(JSON.stringify(chartDataRaw.at(-1)));
      selData["date"] = dat;
      highlightCandles = false;
    }

    // Historical
    if (dataHistorical.length > 0) {
      if (dat <= dataHistorical.at(-1).date) {
        dataHist = mouseDate(xt.invert(xPixels), dataHistorical);
      } else {
        dataHist = JSON.parse(JSON.stringify(dataHistorical.at(-1)));
        dataHist["date"] = dat;
        highlightCandles = false;
      }
    }
    // Data forecast
    if (dataFcst.length > 0) {
      if (dat <= dataFcst.at(-1).date) {
        dataF = mouseDate(xt.invert(xPixels), dataFcst);
      } else {
        dataF = JSON.parse(JSON.stringify(dataFcst.at(-1)));
        dataF["date"] = dat;
        highlightCandles = false;
      }
    }

    let xPix = xt(selData.date);
    // Showing elements
    for (let hoverElement of D3Chart.hoverElements) {
      hoverElement.show({
        yPixels,
        xPix,
        selData,
        dateFormat: _this.settings.dateFormat,
        xt,
        highlightCandles
      });
    }

    const yt = svg.y;
    const yt2 = svg.y2;
    const ytList = [yt, yt2, yt2];
    const dataYtList = [
      selData && highlightCandles ? selData : {},
      dataF && highlightCandles ? dataHist : {},
      dataF && !highlightCandles ? dataF : {}
    ];
    const keyYtList = ["close", _this.settings.fieldUp2, "mean"];

    for (let [index, hoverElementDot] of D3Chart.hoverElementDots.entries()) {
      hoverElementDot.show({
        xPix,
        yt: ytList[index],
        dataYt: dataYtList[index],
        keyYt: keyYtList[index],
        i: index
      });
    }

    if (highlightCandles) {
      select(".dot" + D3Chart.name + 2).style("opacity", 0);
    } else {
      select(".dot" + D3Chart.name + 0).style("opacity", 0);
      select(".dot" + D3Chart.name + 1).style("opacity", 0);
    }
  }
  function mouseout() {
    // Hiding elements
    for (let hoverElement of D3Chart.hoverElements) {
      hoverElement.hide();
    }
    for (let hoverElement of D3Chart.hoverElementDots) {
      hoverElement.hide();
    }
  }
  setupMouseEvents(_this, svg, "", "", mouseover, mouseout);
}

export function setupMouseEvents(
  _this,
  svg,
  auxName,
  chartName,
  mouseover,
  mouseout
) {
  svg
    .append("defs")
    .append("clipPath")
    .attr("id", "clip" + auxName + chartName)
    .append("rect")
    .attr("width", svg.width)
    .attr("height", svg.height);

  const hoverGroup = svg
    .append("g")
    .attr("class", "hoverParent" + auxName + chartName)
    .attr("clip-path", `url(#clip${auxName + chartName})`);
  hoverGroup
    .append("rect")
    .attr("width", svg.width)
    .attr("height", svg.height)
    .style("fill", "rgba(0,0,0,0)")
    .on("mouseover", mouseover)
    .on("mouseover", mouseover)
    .on("mousemove", mouseover)
    .on("mouseout", mouseout);
}
